import { createRoutingURI, getRootSlug } from '@scripts/utils/domain';
import { TeaserCampaignProps } from 'ech-components/src/components/TeaserCampaign';
import { ImageInterface } from 'ech-components/src/types';

const highlightModuleService = (data: {
  title: string;
  leadText: { leadText: string };
  backgroundImage: ImageInterface;
  logo: ImageInterface['image'];
  hubReference: {
    __typename: string;
    navigationTitle: string;
    title: string;
    node_locale: string;
    slug: string;
  };
}) => {
  const highlightModuleProps: TeaserCampaignProps = data
    ? {
        title: data.title,
        lead: data?.leadText?.leadText,
        backgroundImage: data.backgroundImage,
        logo: data.logo,
        link: {
          linkText:
            data.hubReference.navigationTitle || data.hubReference.title,
          url: createRoutingURI(
            getRootSlug(data.hubReference, data.hubReference.node_locale),
          ),
          variant: 'internal',
        },
      }
    : null;

  return highlightModuleProps;
};

export default highlightModuleService;
